import styled from "styled-components";

export const FAQContainer = styled.div`
  margin-top: 5vh;
  margin-bottom: calc(8vh + 20px);
  margin-left: 5%;
  margin-right: 5%;
  line-height: 1.5em;
  font-family: "Pretendard", sans-serif;
`;

export const FAQHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1vh;
`;

export const FAQTitle = styled.h4`
  font-size: 18px;
  margin: 0;
`;

export const AllViewLink = styled.p`
  font-size: 12px;
  color: #414247;
  font-weight: 400;
  cursor: pointer;
  margin: 0;
`;

export const FAQList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const FAQItem = styled.li`
  font-size: 15px;
  margin: 10px 0;
  line-height: 1.7;
  cursor: pointer;
  text-align: left;

  &:hover {
    color: #1FBC70;
  }
`;
